import 'whatwg-fetch';
import { v4 as uuidv4 } from 'uuid';
import { getLinkToken } from '../commonUtil/util';
import { uaParser, LIVESEND_SERVICE_URL } from '../commonUtil/constants';
import ApplicationEntity from '../commonUtil/appEntity';

const sessionTokenId = uuidv4();

function baseEvent() {
    // Seems DA events API don't accept 'dev' as tenant name,
    const tenant = ApplicationEntity.getInstance().tenant || 'tenant';
    const uaResult = uaParser.getResult();

    const event = {
        Tenant: tenant,
        UserId: 'public_user',
        CollectedAt: new Date().toISOString(),
        Trace: {
            Product: 'Engagement Viewer WebApp',
            Application: 'Engagement Viewer',
            SessionToken: sessionTokenId,
            OperatingSystem: uaResult.os.name,
            OperatingSystemDetail: uaResult.os.version,
            Context: {
                Tenant: tenant,
                UserAgent: uaResult.ua
            }
        }
    };

    return event;
}

function getBaseUrl(serviceName) {
    return `${LIVESEND_SERVICE_URL}/${serviceName}?invitationid=${getLinkToken()}`;
}

async function logUXEvent(event) {
    const url = getBaseUrl('SeismicLogEvents');

    const result = fetch(url, {
        body: JSON.stringify(event),
        headers: {
            'content-type': 'application/json'
        },
        dataType: 'Json',
        contentType: 'application/json',
        method: 'POST'
    });
    return result;
}

function handleEvent(createdEvent, callback = () => {}) {
    const event = {
        ...baseEvent(),
        ...createdEvent
    };

    try {
        logUXEvent(JSON.stringify([{ WrappedEvent: event }]));
    } catch (e) {
        callback();
        console.error('UXEvent log failed.', e);
        console.error(event);
    }
}

function appOpenEvent() {
    handleEvent({
        SubType: 'ux-app-open',
        Type: 'ux-event',
        DataVersion: 'e7f84b2d-8b7e-4e4f-bc8b-56022714204c'
    });
}

function navigateViewEvent(eventContext) {
    handleEvent({
        UXContext: eventContext.Context,
        Target: eventContext.Target,
        SubType: 'ux-navigate',
        Type: 'ux-event',
        DataVersion: 'e7f84b2d-8b7e-4e4f-bc8b-56022714204c'
    });
}

function contentOpenEvent(eventContext) {
    handleEvent({
        UXContext: eventContext.Context,
        Target: eventContext.Target,
        SubType: 'ux-content-open',
        Type: 'ux-event',
        DataVersion: 'e7f84b2d-8b7e-4e4f-bc8b-56022714204c'
    });
}

export default {
    appOpenEvent,
    navigateViewEvent,
    contentOpenEvent
};
